import React from 'react';

const TypingIndicator = () => (
    <div className="typing-indicator">
        <div className="typing-bubble">
            <span className="typing-dot" />
            <span className="typing-dot" />
            <span className="typing-dot" />
        </div>
        <span className="typing-label">Customer is typing...</span>
    </div>
);

export default TypingIndicator;
